<template>
  <FormLabel :required="required" :paddedtext="true" :text="text" :error="forceError || error" :tag="'div'" :style="pickerShown ? 'z-index:4' : null">
    <input class="aoformfield aoformfield_datefield" :placeholder="placeholder" autocomplete="off" type="text" :readonly="disabled || $store.getters.loading" inputmode="numeric" v-maska :data-maska="masktemplate" :maxlength="range ? 23 : 10" :name="name" @focus="pickerShown" @blur="filledCheck" v-model="val">
    <button class="aoformlabel__datepick-summon-button" :disabled="disabled || $store.getters.loading" aria-label="Show datepicker" @click.stop.prevent="summonPicker">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="17" rx="2" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7 16H8V17H7V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.5 16H12.5V17H11.5V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 16H17V17H16V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7 12H8V13H7V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.5 12H12.5V13H11.5V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 12H17V13H16V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 2V6" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 2V6" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <Transition name="fade">
      <DatePicker v-if="range" ref="picker" v-show="pickerShown" is-range @click.stop.prevent v-model.range="pickedDate" v-click-outside="() => pickerShown = false" />
      <DatePicker v-else ref="picker" v-show="pickerShown" @click.stop.prevent v-model="pickedDate" v-click-outside="() => pickerShown = false" />
    </Transition>
  </FormLabel>
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { vMaska } from 'maska'
import 'v-calendar/dist/style.css'
import { Calendar, DatePicker } from 'v-calendar'
import vClickOutside from 'click-outside-vue3'

export default {
  //eslint-disable-next-line
  components: { FormLabel, Calendar, DatePicker },
  mixins: [FormField],
  directives: { maska: vMaska, clickOutside: vClickOutside.directive },
  props: {
    forceError: { type: String, default: '' },
    required: { type: Boolean, default: false },
    startAt: { type: String },
    name: { type: String, required: true },
    modelValue: { type: String, default: '' },
    text: { type: String, required: true },
    placeholder: { type: String },
    disabled: { type: Boolean, default: false },
    range: { type: Boolean, default: false },
    validation: { type: Function, default: () => '' },
    filled: { type: Function, default: (v) => v.length == 10 ? true : false }
  },
  data: () => ({
    pickedDate: undefined,
    pickerShown: false,
    error: '',
    masktemplate: '##.##.####'
  }),
  methods: {
    summonPicker() {
      this.pickerShown = !this.pickerShown
    },
    isValidDate(string) {
      if (string.includes(' — ')) {
        let str = string.split(' — ')
        return this.isValidDate(str[0]) && this.isValidDate(str[1])
      }
      if (string[0] > 3 || string[0] == 3 && string[1] > 1)
        return false
      if (string[3] > 1 || string[3] == 1 && string[4] > 2)
        return false

      if (string.length == 10) {
        let split = string.split('.')
        let dd = parseInt(split[0])
        let mm = parseInt(split[1]) - 1
        let yyyy = parseInt(split[2])
        if ([dd, mm, yyyy].find(el => isNaN(el)) !== undefined || dd < 1 || yyyy < 1 || mm < 0)
          return false
        let date = new Date(yyyy, mm, dd)
        if ((date.getDate() !== dd) || (date.getMonth() !== mm) || (date.getFullYear() !== yyyy))
          return false
        let current = new Date(), tooOld = new Date().setFullYear(current.getFullYear() - 100)
        if ((date > current) || (date < tooOld))
          return false
      }
      return true
    },
    filledCheck() {
      if (this.modelValue == '') return this.error = ""
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
      }
    }
  },
  computed: {
    val: {
      get() { return this.modelValue },
      set(value) { this.$emit('update:modelValue', value) },
    },
  },
  mounted() {
    if (this.startAt)
      this.$refs.picker.move(Date.parse(this.startAt))
    if (this.range) {
      this.masktemplate = '##.##.#### — ##.##.####'
    }
  },
  watch: {
    pickedDate(date) {
      if (!date) return
      let textdate
      if (!this.range)
        textdate = ('' + date.getDate()).padStart(2, 0) + '.' + ('' + (date.getMonth() + 1)).padStart(2, 0) + '.' + date.getFullYear()
      else {
        let start = date.start, end = date.end
        textdate = (('' + start.getDate()).padStart(2, 0) + '.' + ('' + (start.getMonth() + 1)).padStart(2, 0) + '.' + start.getFullYear())
          + ' — '
          + (('' + end.getDate()).padStart(2, 0) + '.' + ('' + (end.getMonth() + 1)).padStart(2, 0) + '.' + end.getFullYear())

      }
      this.$emit('update:modelValue', textdate)
      this.pickerShown = false
    },
    modelValue(newVal) {
      if (!this.isValidDate(newVal))
        this.error = 'Некорректная дата'
      else {
        this.error = ''
        this.error = this.validation(newVal)
      }

      this.filledCheck()
      /*
      if (newVal && !this.error) 
        this.$store.dispatch('callAction', this.name)*/
    },
  }
}
</script>

<style lang="sass">
.vc-container
  margin-left: auto
  position: absolute
  right: 0
  top: 100%
.aoformlabel__datepick-summon-button[disabled]
  pointer-events: none !important
  cursor: auto !important
.aoformfield_datefield
  &::placeholder
    opacity: 0.3
  &:not(:focus)::placeholder
    opacity: 0
</style>